import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, PILLARS, CONTACT } from "../../data/content";

export const Footer = () => (
  <footer className="bg-night border-t border-gold/15 text-white/70" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16">
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Logo size="h-16" />
          <p className="mt-5 text-sm leading-relaxed max-w-xs font-body">
            Votre partenaire stratégique pour la diaspora et les marchés africains. Rigueur européenne, ancrage local.
          </p>
        </div>

        <div>
          <h4 className="font-display text-sm uppercase tracking-[0.2em] text-gold mb-5">Navigation</h4>
          <ul className="space-y-3 text-sm font-body">
            {NAV.concat([{ label: "Les pays", to: "/pays" }, { label: "Contact", to: "/contact" }]).map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="hover:text-white transition-colors">{n.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm uppercase tracking-[0.2em] text-gold mb-5">Nos pôles</h4>
          <ul className="space-y-3 text-sm font-body">
            {PILLARS.map((p) => (
              <li key={p.key}>
                <Link to="/expertises" className="hover:text-white transition-colors">{p.title}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm uppercase tracking-[0.2em] text-gold mb-5">Contact</h4>
          <ul className="space-y-3 text-sm font-body">
            <li className="flex items-start gap-3"><Mail size={16} className="text-gold mt-0.5" /><a href={`mailto:${CONTACT.email}`} className="hover:text-white transition-colors">{CONTACT.email}</a></li>
            <li className="flex items-start gap-3"><Phone size={16} className="text-gold mt-0.5" /><a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="hover:text-white transition-colors">{CONTACT.phone}</a></li>
            <li className="flex items-start gap-3"><MapPin size={16} className="text-gold mt-0.5" /><span>{CONTACT.address}</span></li>
            <li className="text-white/50">{CONTACT.locations}</li>
          </ul>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs font-body text-white/45">
        <p>© {new Date().getFullYear()} Bridge Partners. Tous droits réservés.</p>
        <div className="flex items-center gap-6">
          <Link to="/contact" className="hover:text-white transition-colors">Mentions légales</Link>
          <Link to="/contact" className="hover:text-white transition-colors">Confidentialité</Link>
          <Link to="/" className="inline-flex items-center gap-1 hover:text-white transition-colors">Retour à l'accueil <ArrowUpRight size={13} /></Link>
        </div>
      </div>
    </div>
  </footer>
);
